/*
 * @Author: zhujiapeng
 * @Date: 2021-01-27 10:53:56
 * @LastEditors: zhujiapeng
 * @LastEditTime: 2021-01-28 11:33:26
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */
import React, { useState } from 'react';
import Bus from '../../core/bus';
import WEBTRACING from '../../core/buryingPoint';
import './Setting.less';

const list = [
  {
    id: 'black',
    color: 'linear-gradient(270deg, #282A34 0%, #3A3E46 100%)',
    name: '黑色'
  },
  {
    id: 'red_orange',
    color: 'linear-gradient(315deg, #FF9A59 0%, #F35E5E 100%)',
    name: '红橙色'
  },
  {
    id: 'orange',
    color: 'linear-gradient(90deg,rgba(255,183,108,1) 0%,rgba(255,134,81,1) 100%)',
    name: '橙色'
  },
  {
    id: 'blue',
    color: 'rgba(1,86,255,1)',
    name: '蓝色'
  },
  {
    id: 'white',
    color: 'rgba(244,244,244,1)',
    name: '白色'
  }
];

const Setting = () => {
  const [open, setOpen] = useState(false);
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 0);
  return (
    <div className="bag_setting">
      {
        !open &&
        <div
          className='settingIcon'
          onClick={() => {
            WEBTRACING('Web_face_detection', '点击了设置主题色的设置开关');
            setOpen(true);
          }}
        >
          <img src='https://image.xiaomaiketang.com/xm/Ra74MH3ZfJ.png' />
        </div>
      }
      {
        !!open && <div className='settingBag'>
          <div className='settingBox'>
            <div className='tit'>主题色</div>
            {
              list.map((item) => {
                return (
                  <div
                    className='colorBox'
                    style={{ background: item.color }}
                    key={item.id}
                    onClick={() => {
                      WEBTRACING('Web_face_detection', `选择了${item.name}主题`);
                      setTheme(item.id);
                      localStorage.setItem('theme', item.id);
                      Bus.trigger('faceColor', item.id);
                    }}
                  >
                    {
                      item.id === theme && <img src='https://image.xiaomaiketang.com/xm/DwzPYjiBbJ.png' />
                    }
                  </div>
                );
              })
            }
            <div
              className='close'
              onClick={() => {
                setOpen(false);
              }}
            >
              <img src='https://image.xiaomaiketang.com/xm/jRGQ4HwCDC.png' /> </div>
          </div>
        </div>
      }
    </div>
  );
}

export default Setting;